var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.quickconnects)?_c('div',{staticClass:"qc"},[_c('v-layout',{attrs:{"justify-center":""}},[_c('QCCard',{attrs:{"qc":_vm.quickconnects}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }